import { TimerManager } from "../player/timer-manager";

export class IdleTimer {
  private timers = new TimerManager();
  private deadline = 0;

  constructor(
    private totalSeconds: number,
    private warningSeconds: number,
    private onWarning: (seconds: number) => void,
    private onExpired: () => void,
  ) {}

  reset(): void {
    this.timers.clearAll();
    this.deadline = Date.now() + this.totalSeconds * 1000;
    const warningDelay = Math.max(0, (this.totalSeconds - this.warningSeconds) * 1000);
    this.timers.timeout(() => {
      this.tick();
      this.timers.interval(() => this.tick(), 1000);
    }, warningDelay);
    this.timers.timeout(this.onExpired, this.totalSeconds * 1000);
  }

  stop(): void { this.timers.clearAll(); }

  private tick(): void { this.onWarning(Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000))); }
}
